import AppDispatcher from '../dispatcher/AppDispatcher';
import CodeConstants from '../constants/CodeConstants';
import PackAPI from '../utils/PackAPI';

export default {

  search: (pack, pattern) => {
    PackAPI
      .searchCodes(pack, pattern)
      .then(codes => {
        AppDispatcher.dispatch({
          actionType: CodeConstants.RECIEVE_CODES,
          codes: codes
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: CodeConstants.RECIEVE_CODES_ERROR,
          message: message
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/actions/CodeActions.js